import { useRef } from 'react';
import { useDataModel, extend, params } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import {
  string as stringType, arrayOf as arrayOfType, number as numberType
} from '@thd-nucleus/data-sources/react/dataModel/prop-types';
import { useSpecialBuy } from '../context/SpecialBuyProvider';

const getItemIds = (products) => products.map(({ itemId }) => itemId);

export const INITIAL_NUM_ITEMS_TO_LOAD = 8;
export const MAX_NUM_ITEMS_TO_LOAD = 16;

export const useSearchProducts = (category, isFetchAllItemIds) => {
  const { selectedCategory } = useSpecialBuy();
  const { storeId } = useStore();
  const isSelected = Object.is(selectedCategory, category);
  const shouldLoad = useRef(isSelected);

  if (isSelected) shouldLoad.current = true;
  const allItemIds = category.products.map((product) => (product.itemId));
  const firstItemIds = allItemIds.slice(0, INITIAL_NUM_ITEMS_TO_LOAD);
  const remainingItemIds = allItemIds.slice(INITIAL_NUM_ITEMS_TO_LOAD, MAX_NUM_ITEMS_TO_LOAD);

  const firstItemsResponse = useDataModel('searchModel', {
    variables: {
      itemIds: firstItemIds,
      storeId,
    },
    ssr: false,
    skip: !firstItemIds.length
      || storeId === '8119'
      || !shouldLoad.current
  });

  const remainingItemsResponse = useDataModel('searchModel', {
    variables: {
      itemIds: remainingItemIds,
      storeId,
    },
    ssr: false,
    skip: !isFetchAllItemIds
      || !remainingItemIds.length
      || storeId === '8119'
      || !shouldLoad.current
  });

  const firstSearchApiProducts = firstItemsResponse?.data?.searchModel?.products || [];
  const remainingSearchApiProducts = remainingItemsResponse?.data?.searchModel?.products || [];

  const itemIds = [...getItemIds(firstSearchApiProducts), ...getItemIds(remainingSearchApiProducts)];
  const itemIdsToDisplay = [...new Set(itemIds)];

  return {
    itemIdsToDisplay,
    isLoading: firstItemsResponse?.loading || remainingItemsResponse?.loading || false,
  };
};

useSearchProducts.dataModel = extend({
  searchModel: params({ itemIds: arrayOfType(stringType()) })
    .shape({
      id: stringType(),
      products: params({ startIndex: numberType() })
        .arrayOf(extend({}, ProductPod.dataModel.product))
    }),
});
